'use strict';

class GeoNavigationModal {
  constructor() {
    this.$modal = $('#geoNavigationModal');
    this.$otherCountries = $('.js-show-other-countries');
    this.$changeLocaleModal = $('#changeLocale');
    this.cookieName = 'hide_geo_redirect';
  }

  init() {
    this.showModal();
    this.events();
  }

  showModal() {
    const checkCookie = document.cookie.match(new RegExp(`(^|;\\s*)${this.cookieName}=([^;]*)`));
    if (!checkCookie) {
      this.$modal.modal('show');
    }
  }

  events() {
    this.$modal.on('click', '.modal-header-btn-close, .js-show-other-countries', () => {
      this.$modal.modal('hide');
    });

    this.$modal.on('hidden.bs.modal', () => {
      this.setGeoNavigationCookie();
    });

    this.$otherCountries.on('click', () => {
      this.$modal.on('hidden.bs.modal', () => { // wait for the first modal to close, to open the change locale modal
        this.$changeLocaleModal.modal('show');
      });
    });
  }

  setGeoNavigationCookie() {
    document.cookie = `${this.cookieName}=true; path=/;`;
  }
}

const geoNavigationModal = new GeoNavigationModal;
export default geoNavigationModal;